import React from "react";
const axios = require('axios');

export default class ProductElement extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            showMeters: false,
            products: [],
            selectedCategories: [],
            selectedSizes: [],
            categories: this.props.settings.categories,
            sizes: this.props.settings.sizes,
        }

        this.switchMeters = this.switchMeters.bind(this);
        this.isCategoryActive = this.isCategoryActive.bind(this);
        this.isSizeActive = this.isSizeActive.bind(this);
        this.addRemoveCategory = this.addRemoveCategory.bind(this);
        this.addRemoveSize = this.addRemoveSize.bind(this);
    }

    componentDidMount(){
        this.loadMotors();
    }


    loadMotors()
    {
        let categoryIds = [];
        for (const category of this.state.categories) {
            categoryIds.push(category.id);
        }
        axios.get('motors-api', {
            params: {
                categories: this.state.selectedCategories.length ? this.state.selectedCategories : categoryIds,
                lengths: this.state.selectedSizes,
            },
        }).then((response) => {

            this.setState({
                products: response.data
            })
        });
    }

    switchMeters()
    {
        this.setState({
            showMeters: !this.state.showMeters
        })
    }

    isCategoryActive(id)
    {
        return this.state.selectedCategories.indexOf(id) >= 0;
    }

    isSizeActive(id)
    {
        return this.state.selectedSizes.indexOf(id) >= 0;
    }

    addRemoveCategory(id)
    {
        let categories = this.state.selectedCategories;
        if (categories.indexOf(id) >= 0) {
            categories = []
        } else {
            categories = [id];
        }
        this.setState({
            selectedCategories: categories
        }, () => {
            this.loadMotors();
        });
    }

    addRemoveSize(id)
    {
        const sizes = this.state.selectedSizes;
        if (sizes.indexOf(id) >= 0) {
            sizes.splice(sizes.indexOf(id), 1);
        } else {
            sizes.push(id);
        }
        this.setState({
            selectedSizes: sizes
        }, () => {
            this.loadMotors();
        });
    }

    render() {
        const categories = this.state.categories;
        const sizes = this.state.sizes;
        const messages = [];
        for (const id of this.state.selectedCategories) {
            for (const cat of categories) {
                if (cat.id === id && cat.message) {
                    messages.push(cat.message);
                }
            }
        }

        return <div className="products__inner">
                <div className="products__filters">

                    {categories.length > 0 && <div className="products__filter-section">
                        <h3>Filter by type</h3>
                        <ul>
                            {categories.map((category) => {
                                return <li key={`category_${category.id}`}>
                                    <a
                                       onClick={(e) => { e.preventDefault(); this.addRemoveCategory(category.id) }}
                                       className={this.isCategoryActive(category.id) ? 'on' : ''}>{category.title} <span></span></a>
                                </li>
                            })}
                        </ul>
                    </div>}
                    {sizes.length > 0 && <div className="products__filter-section">
                        <h3>Filter by length</h3>
                        <p className="products__filter-switch">
                            Change to metres <span className={this.state.showMeters ? 'on' : ''} onClick={this.switchMeters}></span>
                        </p>
                        <ul>
                            {sizes.map((size) => {
                                return <li key={`size_${size.id}`}>
                                    <a
                                        onClick={(e) => { e.preventDefault(); this.addRemoveSize(size.id) }}
                                        className={this.isSizeActive(size.id) ? 'on' : ''}>
                                        {this.state.showMeters ? size.meters : size.inches}
                                        <span></span>
                                    </a>
                                </li>
                            })}
                        </ul>
                    </div>}
                </div>
                <div className="products__grid-wrapper">

                    {messages.length > 0 && <div className={'products__message'}>
                        {messages.map((message, index) => {
                            return <div key={`message_${index}`} dangerouslySetInnerHTML={{__html: message}}></div>
                        })}
                    </div>}

                    {this.state.products.length > 0 && <div className="products__grid">
                        {this.state.products.map((product) => {
                            return <div className="product-card" key={`product_${product.id}`}>
                                <a href={product.link} className="product-card__inner">
                                    <div className="product-card__image">
                                        {!!product.image && <img src={product.image} alt={product.title} /> }
                                    </div>
                                    <div className="product-card__title">
                                        <h3>{product.title}</h3>
                                        <p>{product.sub_title}</p>
                                    </div>
                                    <div className="product-card__body">
                                        <p>
                                            {product.short_description}
                                        </p>
                                    </div>
                                    <div className="product-card__action">
                                        <span className="btn btn--white--solid">Find out more</span>
                                    </div>
                                </a>
                            </div>
                        })}
                    </div>}
                </div>
            </div>


    }

}
